import "./style.css";
import React, { useState, useEffect, useContext } from "react";
import InstagramIcon from "@mui/icons-material/Instagram";
import Logo from "../../../../resources/logo.png";
import taperFadeImg from "../../../../resources/formacije.jpg";
import { CartContext } from "../../../../context/CartContext";
import { host } from "../../../../config/Config";
import EducationBreadcrumb from "../../../../common/EducationBreadcrumb";

export const Formation = () => {
    const phoneNumber = "+381 60-3859-426";
    const { addToCart } = useContext(CartContext);
    const [price, setPrice] = useState(0);
    const [loading, setLoading] = useState(true);
    const [hasAvailableSlots, setHasAvailableSlots] = useState(false);
    const [slotMessage, setSlotMessage] = useState("");
    const [fadeIn, setFadeIn] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);

        // Trigger fade in after a brief delay
        setTimeout(() => {
            setFadeIn(true);
        }, 100);

        fetch(`${host}/api/v1/education-prices/type/formation`)
            .then((response) => response.json())
            .then((data) => {
                setPrice(data.price);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching price:", error);
                setPrice(50);
                setLoading(false);
            });

        fetch(`${host}/api/v1/education-slots/type/formation`)
            .then((response) => response.json())
            .then((slots) => {
                const activeSlots = slots.filter(
                    (slot) =>
                        slot.status === "ACTIVE" && slot.availableSlots > 0
                );
                if (activeSlots.length > 0) {
                    setHasAvailableSlots(true);
                } else {
                    setHasAvailableSlots(false);
                    const hasSlots = slots.some(
                        (slot) => slot.status === "ACTIVE"
                    );
                    setSlotMessage(
                        hasSlots
                            ? "Svi termini su trenutno popunjeni. Molimo kontaktirajte nas za više informacija."
                            : "Trenutno nema dostupnih termina za ovu edukaciju. Molimo kontaktirajte nas."
                    );
                }
            })
            .catch((error) => {
                console.error("Error fetching slots:", error);
                setHasAvailableSlots(false);
                setSlotMessage(
                    "Trenutno nema dostupnih termina za ovu edukaciju."
                );
            });
    }, []);

    const HandleOpenMap = () => {
        const url = `https://maps.app.goo.gl/6wxPp2i9rRZ45HQs6`;
        window.open(url, "_blank");
    };

    return (
        <div className='page-formation'>
            <EducationBreadcrumb />

            <div className={`items-formation ${fadeIn ? "fade-in" : ""}`}>
                <h1
                    style={{
                        fontSize: "37px",
                        color: "#be9455",
                        letterSpacing: "1px",
                        textShadow:
                            "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                    }}
                >
                    The shape code
                </h1>
                <h1 style={{ marginTop: "-19px" }}>Formacija</h1>
                <h1 style={{ marginTop: "-19px" }}>Nivo 2</h1>
                <p>
                    četvorodnevna napredna edukacija fokusirana je za
                    izradu-učenje preciznih i sofisticiranih frizura kroz
                    razumevanje struktura, ravnoteže i trodimenzionalnih oblika.
                    Namenjena je profesionalcima koji žele da nadograde tehniku
                    i evoluiraju svoj vizuelni pristup oblikovanju kose.
                </p>

                <p
                    style={{
                        textAlign: "center",
                        fontSize: "28px",
                        color: "#be9455",
                        letterSpacing: "1px",
                        textShadow:
                            "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                    }}
                >
                    Cilj edukacije
                </p>
                <p
                    style={{
                        textAlign: "center",
                        marginTop: "-18px",
                        marginBottom: "15px",
                    }}
                >
                    Razviti sposobnost kontrole oblika i proporcija frizure,
                    kroz tehniku preciznost i izraženu interpretaciju
                    individualnog stila svakog polaznika
                </p>
                <p
                    style={{
                        textAlign: "center",
                        fontSize: "28px",
                        color: "#be9455",
                        letterSpacing: "1px",
                        textShadow:
                            "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                    }}
                >
                    Šta polaznici stiču
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Napredne tehnike kontrole forme i strukture frizure
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Razumevanje odnosa između tehnike, balansa i pokreta u
                    frizuri
                </p>
                <p
                    style={{
                        textAlign: "center",
                        marginTop: "-20px",
                    }}
                >
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Primenu tehnika koje omogućavaju personalizaciju i
                    transformaciju oblika u savremene i estetski čiste linije
                </p>

                <p
                    style={{
                        marginTop: "15px",
                        textAlign: "center",
                        fontSize: "28px",
                        color: "#be9455",
                        letterSpacing: "1px",
                        textShadow:
                            "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                    }}
                >
                    Za koga je edukacija namenjena
                </p>
                <p style={{ textAlign: "center", marginTop: "-20px" }}>
                    Za iskusne frizere i barbere koji žele da unaprede tehničko
                    znanje, vizuelnu preciznost i umetnički pristup u kreiranju
                    modernih formi.
                </p>

                <img
                    src={taperFadeImg}
                    style={{
                        width: "80%",
                        height: "auto",
                        borderRadius: "15px",
                        border: "3px solid #be9455",
                        marginTop: "20px",
                        marginBottom: "20px",
                    }}
                    alt='Taper Fade'
                />

                <p style={{ fontSize: "22px" }}>
                    Svaki dan je podeljen u tri ključne faze.
                </p>
                <p style={{ fontSize: "22px", marginBottom: "-10px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Teorija - detaljna analiza, kombinacija oblika i pogodnosti
                </p>
                <p style={{ fontSize: "22px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Demonstracija - kompletno izvođenje svake frizure korak po
                    korak uživo
                </p>
                <p style={{ fontSize: "22px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Praktična vežba - Učesnici samostalno izvode svaku tehniku
                    na profesionalnim lutkama, primenjujući teoriju i preciznost
                    na praksi.
                </p>

                <img
                    src={Logo}
                    style={{ width: "140px", borderRadius: "8px" }}
                />

                <p style={{ fontSize: "22px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Do kraja ove radionice učesnici neće samo izvršavati forme,
                    već će ih dizajnirati sa namerom i samostalnosti
                </p>
                <p style={{ fontSize: "22px", marginBottom: "40px" }}>
                    <span
                        style={{
                            color: "#be9455",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        *
                    </span>{" "}
                    Svi materijali i profesionalne lutke su uključeni u cenu.
                </p>

                {!loading && (
                    <div
                        style={{
                            textAlign: "center",
                            fontSize: "32px",
                            fontWeight: "bold",
                            color: "#be9455",
                            marginTop: "30px",
                            marginBottom: "10px",
                            textShadow:
                                "-1px -1px 0 black, 1px -1px 0 black, -1px 1px 0 black, 1px 1px 0 black",
                        }}
                    >
                        Cena: {price.toLocaleString()} EUR
                    </div>
                )}

                <div
                    className={`buy-button-formation ${
                        !hasAvailableSlots ? "disabled" : ""
                    }`}
                    onClick={() => {
                        if (hasAvailableSlots) {
                            addToCart({
                                id: "formation",
                                name: "Formation Workshop",
                                price: price,
                                category: "workshop",
                            });
                        }
                    }}
                    style={{
                        opacity: hasAvailableSlots ? 1 : 0.5,
                        cursor: hasAvailableSlots ? "pointer" : "not-allowed",
                    }}
                >
                    <p>{hasAvailableSlots ? "Dodaj u korpu" : "Nedostupno"}</p>
                </div>
                {slotMessage && (
                    <p
                        style={{
                            color: "#e74c3c",
                            textAlign: "center",
                            marginTop: "10px",
                            fontSize: "19px",
                            fontStyle: "italic",
                        }}
                    >
                        {slotMessage}
                    </p>
                )}
            </div>

            <a
                className='barbershop-zajednica-footer-title-adresa'
                onClick={HandleOpenMap}
                target='_blank'
                rel='noopener noreferrer'
            >
                <div>
                    <h2>Srpskog sovjeta 1a</h2>
                    <h2>11300, Smederevo</h2>
                    <h2> Klikni me</h2>
                </div>
            </a>
            <div className='barbershop-zajednica-footer-title-adresa'>
                <h2>Posetite Instagram</h2>
                <a
                    href='https://www.instagram.com/_zajednica_/'
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{
                        marginTop: "10px",
                        width: "100%",
                        justifyContent: "center",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        color: "#f3f3f3",
                        textDecoration: "none",
                    }}
                >
                    <InstagramIcon
                        style={{ color: "#f3f3f3", fontSize: "40px" }}
                    />
                </a>
            </div>

            <div className='barbershop-zajednica-footer-title'>
                <h2>Ili nas kontaktirajte</h2>
            </div>
            <div className='barbershop-zajednica-footer-phone'>
                <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
            </div>
        </div>
    );
};
